import {
  getMicrocopyWithoutNumber,
  matchLocaleToMicrocopy,
} from '../../../../utils/microcopy.utils'

export const getPaginationMicrocopy = (dynamicData: any, pageLocale: string, text: any) => {
  let nextPrevMicrocopy
  if (dynamicData.allContentfulMicrocopySet?.edges) {
    nextPrevMicrocopy = matchLocaleToMicrocopy(
      dynamicData.allContentfulMicrocopySet.edges,
      'ResourceListing',
      pageLocale
    )
  }

  if (nextPrevMicrocopy) {
    const nextSet = getMicrocopyWithoutNumber(nextPrevMicrocopy, 'NextPAGE', 'text')
    const prevSet = getMicrocopyWithoutNumber(nextPrevMicrocopy, 'PreviousPAGE', 'text')

    if (nextSet && nextSet[0] && nextSet[0].value) {
      text.next = nextSet[0].value
    }

    if (prevSet && prevSet[0] && prevSet[0].value) {
      text.prev = prevSet[0].value
    }
  }
}

export const paginationDisplay = (currentPage: number, pageCount: number) => {
  var current = currentPage,
    last = pageCount,
    delta = 1,
    left = current - delta,
    right = current + delta + 1,
    range = [],
    rangeWithDots = [],
    l

  range.push(1)
  for (let i = current - delta; i <= current + delta; i++) {
    if (i >= left && i < right && i < last && i > 1) {
      range.push(i)
    }
  }

  range.push(last)

  for (let i of range) {
    if (l) {
      if (i - l === 2) {
        rangeWithDots.push(l + 1)
      } else if (i - l !== 1) {
        rangeWithDots.push('...')
      }
    }

    rangeWithDots.push(i)
    l = i
  }

  return rangeWithDots
}
